




import { computed, defineComponent } from '@vue/composition-api';
import { ThemeContext } from '@berlin-front/common/services/ThemeContext';
import { useContext } from '@berlin-front/common/composables/context';
import { bemx } from '@berlin-front/common/utils';

/**
 * ## ロゴ
 *
 * 決済モジュール内に表示するロゴ。
 * NP後払いやatoneなどNPが提供するサービスのロゴだけでなく、
 * ホワイトラベル対応の際には加盟店のロゴを表示することもある。
 * ThemeContextから表示させるロゴを動的に取得する。
 * 静的ファイルとしてプロジェクト内に持つのではなく任意のurlを受け付ける形となる。
 *
 */
export default defineComponent({
  name: 'AppLogo',

  setup() {
    const { themeParameter } = useContext(ThemeContext);
    const logo = computed(() => themeParameter.value.logo);
    const className = bemx('AppLogo');
    return {
      className,
      imgSrc: logo,
    };
  },
});
